import { defineStore } from 'pinia'
export const useLoadingState = defineStore('loadingState', {
    state: () => ({
        loading: false,
    }),
    actions: {
        setLoading(value) {
            this.loading = value;
        },
        startLoading() {
            this.setLoading(true);
        },
        stopLoading() {
            this.setLoading(false);
        }
    },
    getters: {
        isLoading: (state) => state.loading,
    }
});

